import { Usuario } from '@mapa/core';
import { RespostaPaginada } from './shared/model/sgsia/paginacao-sgsia';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DialogService, MessageService, DynamicDialogRef } from "primeng/api";
import { forkJoin, Observable } from "rxjs";
import { AvisosContainerComponent } from "./feature/avisos/avisos-container/avisos-container.component";
import { ControleAcessoService } from "./shared/client/sgsia/controle-acesso/controle-acesso.service";
import { RevisaoSeloService } from "./shared/client/sgsia/revisao-selo/revisao-selo.service";
import { SuspensaoInstituicaoService } from "./shared/client/sgsia/suspensao-instituicao/suspensao-instituicao.service";
import {
    AppMessageService,
    MessageItem,
} from "./shared/core/message/app-message.service";
import { ControleAcessoFiltroSgsia } from "./shared/model/sgsia/controle-acesso-filtro-sgsia";
import { RevisaoSeloFiltroSgsia } from "./shared/model/sgsia/revisao-selo-filtro-sgsia";
import { RevisaoSeloSgsia } from "./shared/model/sgsia/revisao-selo-sgsia";
import { SuspensaoInstituicaoFiltroSgsia } from "./shared/model/sgsia/suspensao-instituicao-filtro-sgsia";
import { AutoLogoutService } from "./shared/service/auto-logout.service";
import { SegurancaService } from "./shared/service/seguranca.service";
import { LocalStorage } from '@ng-idle/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    providers: [DialogService, DatePipe],
})
export class AppComponent implements OnInit {
    constructor(
        private router: Router,
        private messageService: MessageService,
        private appMessageService: AppMessageService,
        private segurancaService: SegurancaService,
        private controleAcessoService: ControleAcessoService,
        private autoLogoutService: AutoLogoutService,
        private dialogService: DialogService,
        private revisaoSeloService: RevisaoSeloService,
        private suspensaoInstituicaoService: SuspensaoInstituicaoService,
        private localStorage: LocalStorage,
        private datePipe: DatePipe
    ) {
        // Redireciona o usuário com o perfil "Analista / Fiscal" para a tela de solicitar acesso/completar cadastro
        const usuario = this.segurancaService.getUsuarioLogado();
        if (this.segurancaService.isAnalistaFiscal()) {
            const filtro: ControleAcessoFiltroSgsia =
                new ControleAcessoFiltroSgsia();
            filtro.idPessoaFiscal = usuario.idPessoa;
            filtro.situacao = "APROVADO";
            filtro.ativo = true;

            this.controleAcessoService.consultar(filtro).subscribe(
                (data) => {
                    if (!data.conteudo || data.conteudo.length === 0) {
                        this.router
                            .navigate(["/gestao-acesso/solicitar-acesso"])
                            .catch((reason) => console.log(reason));
                    }
                },
                (result) => {
                    console.log(result);
                }
            );
        }
    }

    ngOnInit(): void {
        console.log("AppComponent", "ngOnInit");
        this.appMessageService
            .getMsgEmitter()
            .subscribe((item) => this.addMsgItem(item));
        this.autoLogoutService.startService();
        this.mostrarAvisos();
    }

    /**
     * Adiciona o item de mensagem a visualização.
     *
     *  messageItem
     */
    private addMsgItem(messageItem: MessageItem): void {
        this.messageService.add({
            severity: messageItem.type,
            detail: messageItem.msg,
            closable: true,
            // sticky: true
            life: 10000,
        });
    }

//verificar forma de mover essa implementação para
    mostrarAvisos() {
        const usuario =this.segurancaService.getUsuarioLogado();
        if (!usuario) {
            setTimeout(() => {
                this.mostrarAvisos();
            }, 1000);
            return;
        }

        if (
            !(
                this.segurancaService.isAnalistaFiscal() ||
                this.segurancaService.isGestor() ||
                this.segurancaService.isEstabelecimento()
            )
        ) {
            return;
        }

        if(this.avisoExibido(usuario)){
            return;
        }

        const filtroSuspensao = new SuspensaoInstituicaoFiltroSgsia();
        filtroSuspensao.order='desc';
        filtroSuspensao.orderBy='dataSuspensao';
        filtroSuspensao.suspenso = "SIM";

        const filtroRevisao = new RevisaoSeloFiltroSgsia();
        filtroRevisao.order='desc';
        filtroRevisao.orderBy='dataSolicitacao';
        if (this.segurancaService.isEstabelecimento()) {
            filtroRevisao.situacoes = [
                RevisaoSeloSgsia.SITUACAO_REVISAO_EM_REVISAO,
                RevisaoSeloSgsia.SITUACAO_REVISAO_SUSPENSO,
                RevisaoSeloSgsia.SITUACAO_REVISAO_REVISADA,
            ];
        }
        if (this.segurancaService.isAnalistaFiscal()) {
            filtroRevisao.situacoes = [
                RevisaoSeloSgsia.SITUACAO_REVISAO_EM_REVISAO,
                RevisaoSeloSgsia.SITUACAO_REVISAO_SUSPENSO,
            ];
        }
        if (this.segurancaService.isGestor()) {
            filtroRevisao.situacoes = [
                RevisaoSeloSgsia.SITUACAO_REVISAO_REVISADA,
            ];
        }

        const revisaoSource = this.revisaoSeloService.consultar(filtroRevisao);
        const sources: Array<Observable<RespostaPaginada<any>>> = [revisaoSource];

        if(!this.segurancaService.isEstabelecimento()){
          const suspensaoSource = this.suspensaoInstituicaoService.consultar(filtroSuspensao);
          sources.push(suspensaoSource);
        }

        forkJoin(sources).subscribe(
            (results) => {
                if ( results.find(it => it.totalItens > 0) === undefined) {
                    return;
                }
                const suspensoes = results.length > 1 ? results[1] : undefined;
                this.marcaAvisoExibido(usuario);
                const ref = this.dialogService.open(AvisosContainerComponent, {
                    data: {
                        revisoes: results[0],
                        suspensoes: suspensoes,
                    },
                    contentStyle: {
                        "min-height": "400px",
                        "max-height": "90%",
                        overflow: "auto",
                    },
                    header: "Avisos",
                    width: "95%",
                    height: "100%",
                    closable: false,
                });

                ref.onClose.subscribe((c) => {});
            },
            (result) => {
                this.appMessageService.addMensagensResposta(result);
            }
        );
    }

    private avisoExibido(usuario: Usuario):boolean{
        const ultimaExibicao = localStorage.getItem(usuario.idPessoa.toString());
        return ultimaExibicao === this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    }

    private marcaAvisoExibido(usuario: Usuario){
        localStorage.setItem(usuario.idPessoa.toString(), this.datePipe.transform(new Date(), 'dd/MM/yyyy') );
    }

}
